import { c as _c } from "react/compiler-runtime";
import { OptimizationStartResponse } from '@/app/api/optimization/startOptimization/models';
import { OptimizationOptions } from '@/services/bayesianApi/optimizationModels';
import { createOptimizeRequestData } from '@/utils/bayesian/optimizeUtils';
import { showInformation } from '@/utils/toast';
import useNetwork from './useNetwork';
import useAssumptions from '../assumptionSets/useAssumptions';
import useAssumptionSets from '../assumptionSets/useAssumptionSets';
import useRequirements from '../assumptionSets/useRequirements';
import useMutationWithFeedback from '../utils/useMutationWithFeedback';
const useVariableOptimizationJob = (networkId, options) => {
  const $ = _c(17);
  let t0;
  if ($[0] !== networkId) {
    t0 = {
      networkId
    };
    $[0] = networkId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    network
  } = useNetwork(t0);
  let t1;
  if ($[2] !== networkId) {
    t1 = {
      networkId
    };
    $[2] = networkId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: assumptionSets
  } = useAssumptionSets(t1);
  let t2;
  if ($[4] !== networkId) {
    t2 = {
      networkId
    };
    $[4] = networkId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: assumptions
  } = useAssumptions(t2);
  let t3;
  if ($[6] !== networkId) {
    t3 = {
      networkId
    };
    $[6] = networkId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: requirements
  } = useRequirements(t3);
  let t4;
  if ($[8] !== assumptionSets || $[9] !== assumptions || $[10] !== network || $[11] !== networkId || $[12] !== requirements) {
    t4 = async t5 => {
      const {
        selectedVariables,
        options: options_0,
        jobName
      } = t5;
      const requestData = createOptimizeRequestData(network, selectedVariables, assumptionSets, assumptions, requirements, options_0, networkId, jobName);
      const response = await fetch("/api/optimization/startOptimization", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestData)
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
      }
      const responseData = (await response.json()) as OptimizationStartResponse;
      const updatedNodeCount = responseData.updatedNodeNames?.length ?? 0;
      if (updatedNodeCount > 0) {
        const message = `Updated CPTs for ${updatedNodeCount} parentless node(s) based on their North Star assumptionSets. This gives us a better starting point for optimizing other nodes.`;
        showInformation(message, {
          duration: 15000
        });
      }
      if (responseData.optimizationStarted === false) {
        showInformation("Optimization completed", {
          description: responseData.message || "No optimization was needed.",
          duration: 15000
        });
        return;
      }
    };
    $[8] = assumptionSets;
    $[9] = assumptions;
    $[10] = network;
    $[11] = networkId;
    $[12] = requirements;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = options?.hideLoadingToast;
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = {
      mutation: t4,
      success: "Optimization successfully started",
      loadingDescription: "Starting optimization...",
      hideLoadingToast: t5,
      error: "Failed to start optimization"
    };
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return useMutationWithFeedback(t6);
};
export default useVariableOptimizationJob;